/**
 * Shared motion vocabulary (Stage 9.5 pattern F1; Stage 12B codification).
 * One easing, three durations, one stagger — marketing and app surfaces both
 * consume these so motion feels like one product. All consumers must pair
 * with a prefers-reduced-motion branch (framer's useReducedMotion or the CSS
 * media query).
 */
export const EASE_OUT_EXPO = [0.16, 1, 0.3, 1] as const
/** CSS string form for transition-timing-function. */
export const EASE_OUT_EXPO_CSS = 'cubic-bezier(0.16, 1, 0.3, 1)'

export const DURATION = {
  /** hover/press feedback */
  fast: 0.15,
  /** reveals, drawers, dropdowns */
  base: 0.25,
  /** section entrances */
  slow: 0.6,
} as const

/** Stagger interval between sibling reveals (seconds). */
export const STAGGER = 0.07

/** Framer-motion transition presets. */
export const transitions = {
  fast: { duration: DURATION.fast, ease: EASE_OUT_EXPO },
  base: { duration: DURATION.base, ease: EASE_OUT_EXPO },
  slow: { duration: DURATION.slow, ease: EASE_OUT_EXPO },
} as const
